import { Injectable } from '@angular/core';
import { QPStore } from 'qp-store';
import { getAppVersion, getDeviceManufacturer, getDeviceModel, getPlatformName } from 'qp-utility';
import { DeviceHandlerService } from 'src/app/shared/services/device-handler/device-handler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoreService extends QPStore {
  constructor(
    private readonly deviceHandler: DeviceHandlerService,
  ) {
    super();
    this.init();
  }

  /**
   * init SDK
   * Set base event data in store
   *  - DeviceInfo
   *  - AsnInfo
   *  - RegionInfo (rule service)
   *  - AppInfo
   *  - UserAgentInfo
   *  - session (session service)
   *  - EventInfo
   *  - UserRegionInfo
   */
  init(): void {
    const newTxt = navigator.userAgent.split('(');
    const userAgentData = [];
    for (let i = 1; i < newTxt.length; i++) {
      userAgentData.push(newTxt[i].split(')')[0]);
    }

    this.setDeviceInfo({
      device: userAgentData[0],
      deviceID: this.deviceHandler.getCurrentDeviceID(),
      deviceGroup: 'TV',
      deviceManufacturer: getDeviceManufacturer(),
      deviceModel: getDeviceModel(),
      deviceType: 'TV',
      platformName: getPlatformName()
    });
    this.setBrowserInfo(this.deviceHandler.getUserAgentDetails());
    this.setAsnInfo({
      asn: environment.app.asn,
      asnOwner: environment.app.asnowner,
    });
    this.setAppInfo({
      appName: 'UNow',
      appVersion: getAppVersion(),
    });
  }
}
